import Swal from 'sweetalert2';
import { fetchConToken, handleError } from '../helpers/fetch';

// Accion para añadir un usuario a varios contratos
//contracts es un array de contratos con id,name,permissions y type
export const contractsAddUser = async ({ userId, contracts }) => {
    try {
        Swal.fire({
            title: 'Cargando...',
            text: 'Por favor espera',
            allowOutsideClick: false,
            showConfirmButton: false,
            willOpen: () => {
                Swal.showLoading();
            },
        });
        const body = contracts
        const result = await fetchConToken(`contracts/users/${userId}/many`, body, 'POST');

        if (!result.ok) {
            throw result.status;
        }

        Swal.fire({
            titleText: 'Guardado',
            text: 'Contratos añadidos correctamente',
            icon: 'success',
            confirmButtonColor: '#3085d6',
        });

        return result.json();


    } catch (err) {
        handleError(err);
        //return rejectWithValue(err);
    }
}